import infoCardElement from '../../../../components/Utils/Cards/InfoCardMethods';
import { calculateDays, formatCurrency, handleDateFormat } from '../../../../services/utils';
import { endorsementActionOptions, endorsementTypeOptions } from './attributeOptions';

const InsuranceEndorsementSummaryObject = ({ insuranceEndorsement, insurancePolicy }) => {
  const {
    comments,
    endorsementAction,
    endorsementDate,
    endorsementType,
    variationAffectPremium,
    variationExemptPremium,
    variationTotalNetPremium
  } = insuranceEndorsement;
  const { validityStart, currency } = insurancePolicy;
  const isModification = endorsementType === 'modification';
  const endorsementActionLabel = endorsementActionOptions.find(action => action.value === endorsementAction)?.label;
  const endorsementTypeLabel = endorsementTypeOptions.find(type => type.value === endorsementType)?.label;

  const dateLabel = type => {
    if (type === 'cut') return 'Fecha de corte';
    if (type === 'modification') return 'Fecha de modificación';
    const dateLabelObject = {
      decrease: { remove: 'Fecha de eliminación', modify: 'Fecha de modificación' },
      increase: { add: 'Fecha de agregación', remove: 'Fecha de eliminación', modify: 'Fecha de modificación' }
    };

    return dateLabelObject[type][endorsementAction];
  };

  const object = {};
  if (endorsementAction) {
    object.endorsementAction = infoCardElement({
      string: true,
      key: 'Acción',
      value: endorsementActionLabel
    });
  }
  object.endorsementType = infoCardElement({
    string: true,
    key: 'Tipo de endoso',
    value: endorsementTypeLabel
  });

  object.endrosementDate = infoCardElement({
    string: true,
    key: dateLabel(endorsementType),
    value: handleDateFormat(endorsementDate)
  });
  if (insuranceEndorsement.endorsementType === 'extension' || insuranceEndorsement.endorsementType === 'cut') {
    object.newTermDuration = infoCardElement({
      string: true,
      key: 'Nueva duración',
      value: calculateDays(validityStart, endorsementDate)
        .toString()
        .concat(' días')
    });
  }

  if (!isModification) {
    object.variationAffectPremium = infoCardElement({
      string: true,
      key: 'Variación de prima afecta',
      value: formatCurrency({ value: variationAffectPremium, addon: ` ${currency}` })
    });
    object.variationExemptPremium = infoCardElement({
      string: true,
      key: 'Variación de prima exenta',
      value: formatCurrency({ value: variationExemptPremium, addon: ` ${currency}` })
    });
    object.variationTotalNetPremium = infoCardElement({
      string: true,
      key: 'Variación de prima total neta',
      value: formatCurrency({ value: variationTotalNetPremium, addon: ` ${currency}` })
    });
  }

  object.comments = infoCardElement({
    string: true,
    key: 'Comentarios',
    value: comments || 'Sin comentarios'
  });

  return object;
};
export default InsuranceEndorsementSummaryObject;
